import { getIn } from 'immutable';



const root = 'nft';

export const getMaxSupply = (state) =>
  getIn(state, [root, 'maxSupply'], 0);
export const getTotalSupply = (state) =>
  getIn(state, [root, 'totalSupply'], 0);

export const getTimestamp = (state) =>
  getIn(state, [root, 'timestamp'], 0);
export const getTimestampPresale = (state) =>
  getIn(state, [root, 'timestampPresale'], 0);
export const getTimestampPresaleEnd = (state) =>
  getIn(state, [root, 'timestampPresaleEnd'], 0);
/*export const getTimestampRaffleEnd = (state) =>
  getIn(state, [root, 'timestampRaffleEnd'], 0);*/
export const getTimestampSale = (state) =>
  getIn(state, [root, 'timestampSale'], 0);

export const getSaleOpen = (state) =>
  getIn(state, [root, 'saleOpen'], false);
export const getPresaleOpen = (state) =>
  getIn(state, [root, 'presaleOpen'], false);
export const getPresalePaused = (state) =>
  getIn(state, [root, 'presalePaused'], false);
/*export const getRaffleEnded= (state) =>
  getIn(state, [root, 'raffleEnded'], false);*/
export const getSoldOut = (state) =>
  getIn(state, [root, 'soldOut'], false);

export const getPricePresale = (state) =>
  getIn(state, [root, 'pricePresale'], 0);
export const getPriceSale = (state) =>
  getIn(state, [root, 'priceSale'], 0);
export const getPrice = (state) =>
  getIn(state, [root, 'price'], 0);


export const getLimitPresale = (state) =>
  getIn(state, [root, 'limitPresale'], 0);
export const getLimitSale = (state) =>
  getIn(state, [root, 'limitSale'], 0);
export const getLimitTx = (state) =>
  getIn(state, [root, 'limitTx'], 0);


export const getTraitsCount = (state) =>
  getIn(state, [root, 'traitsCount'], {});
export const getTraits = (state) =>
  getIn(state, [root, 'traits'], {});
export const getTokens = (state) =>
  getIn(state, [root, 'tokens'], []);
